export function useValidationQuestionsAnnouncement() {
  return {
    heading: 'Introducing Validation Questions',
    imageUrl: 'validation-questions-announcement.png',
    imageAlt: 'Validation questions',
    bodyText:
      'When Luminary reads a set of estate planning documents, it now asks you a short set of targeted questions so the dispositive provision and sub-trust suggestions come out right the first time, getting you to a client-ready deliverable much faster.',
    actionButtons: null,
  };
}
